export const parseTint = (tint: string) => {
  // #330099ff to #330099

  if (tint.length === 9) {
    return tint.substring(0, 7);
  }

  return tint;
};
